<div class="grid" *ngIf="ticket">
  <div class="grid__box grid__box--size-min grid__box--small-padding" *ngIf="ticket.extra_flags && ticket.extra_flags.moveaddr" title="Переезд">
    <app-icon [glyph]="'autotrack'" [size]="'22'" [color]="'gray-dark'"></app-icon>
  </div>

  <div class="grid__box grid__box--size-min grid__box--small-padding" *ngIf="ticket.extra_flags && ticket.extra_flags.iptv_on_ytv === true" title="IPTV на Я">
    <app-icon [glyph]="'iptv на Я'" [size]="'22'" [color]="'gray-dark'"></app-icon>
  </div>

  <div class="grid__box grid__box--size-min grid__box--small-padding" *ngIf="ticket.extra_flags && ticket.extra_flags.prework" title="Медленное подключение">
    <app-icon [glyph]="'snail'" [size]="'22'" [color]="'gray-dark'"></app-icon>
  </div>

  <div class="grid__box grid__box--size-min grid__box--small-padding" *ngIf="ticket.extra_flags && ticket.extra_flags.moveticket" title="Перенос заявки">
    <app-icon [glyph]="'date-move'" [size]="'22'" [color]="'gray-dark'"></app-icon>
  </div>

  <div
    class="grid__box grid__box--size-min grid__box--small-padding"
    *ngIf="ticket.extra_flags && ticket.extra_flags.switching_additional && ticket.ticket_type && ticket.ticket_type.name === 'Дозаказ'"
    title="Гигабитное подключение"
  >
    <app-icon [glyph]="'giga'" [size]="'22'" [color]="'gray-dark'"></app-icon>
  </div>

  <div class="grid__box grid__box--size-min grid__box--small-padding" *ngIf="ticket.extra_flags && ticket.extra_flags.is_gigabit_connection" title="Гигабитное подключение">
    <app-icon [glyph]="'giga'" [size]="'22'" [color]="'gray-dark'"></app-icon>
  </div>
</div>
